import type { IconType } from "@circle-react-shared/Icon/IconNames";

export type ScoreTypes = "high" | "medium" | "low" | "disabled";

export type ActivityCardScoreTypes = Exclude<ScoreTypes, "disabled">;

export interface ActivityScore {
  activity: ScoreTypes;
  label?: string;
  score?: number;
}

interface ScoreBreakdownType {
  activity: ActivityCardScoreTypes;
  category: string;
  display_value: string;
  score: number;
}

export interface ActivityScoreResponse {
  activity_score: ActivityScore;
  community_member_id: number;
  score_breakdown: ScoreBreakdownType[];
}

export interface ActivityScoreDetail {
  activityScore: ActivityScore;
  scoreBreakdown?: ScoreBreakdownType[];
}

export type ActivityResponseMap = Map<number, ActivityScoreDetail>;

export const getScoreIcon = (scoreType: ScoreTypes): IconType => {
  const scores: { [key in ScoreTypes]: IconType } = {
    high: "16-smile",
    medium: "16-neutral",
    low: "16-sad",
    disabled: "16-disabled",
  };
  return scores[scoreType];
};
